import { useEffect, useState } from 'react'
import { SHORTCUTS } from '../hooks/useKeyboardShortcuts'
import useModal from '../hooks/useModal'

function Key({ children }) {
  return <kbd className="px-2 py-0.5 text-[11px] font-mono font-semibold bg-gray-100 border border-gray-300 rounded text-gray-700 shadow-sm">{children}</kbd>
}

export default function KeyboardShortcutsHelp() {
  const [open, setOpen] = useState(false)

  useEffect(() => {
    const show = () => setOpen(true)
    const close = () => setOpen(false)
    window.addEventListener('show-shortcuts-help', show)
    window.addEventListener('close-modal', close)
    return () => {
      window.removeEventListener('show-shortcuts-help', show)
      window.removeEventListener('close-modal', close)
    }
  }, [])

  const { containerProps } = useModal({ onClose: () => setOpen(false), enabled: open })

  if (!open) return null

  return (
    <div className="fixed inset-0 z-50 bg-black/50 flex items-center justify-center p-4" onClick={() => setOpen(false)}>
      <div {...containerProps} aria-labelledby="shortcuts-title"
           className="bg-white rounded-2xl shadow-xl max-w-xl w-full max-h-[85vh] overflow-y-auto" onClick={e => e.stopPropagation()}>
        <div className="flex items-center justify-between px-6 py-4 border-b border-gray-100">
          <h2 className="text-lg font-bold text-gray-800">⌨️ Keyboard Shortcuts</h2>
          <div className="flex items-center gap-2">
            <button onClick={() => setOpen(false)} title="Minimize" className="text-gray-400 hover:text-gray-600 text-2xl leading-none w-8 h-8 flex items-center justify-center rounded hover:bg-gray-100">−</button>
            <button onClick={() => setOpen(false)} title="Close" className="text-gray-400 hover:text-gray-600 text-2xl leading-none w-8 h-8 flex items-center justify-center rounded hover:bg-gray-100">×</button>
          </div>
        </div>
        <div className="p-6 space-y-6">
          {SHORTCUTS.map(group => (
            <div key={group.section}>
              <p className="text-xs font-semibold uppercase tracking-wider text-gray-500 mb-2">{group.section}</p>
              <table className="w-full text-sm">
                <tbody>
                  {group.rows.map((r, i) => (
                    <tr key={i} className="border-t border-gray-50 first:border-t-0">
                      <td className="py-2 pr-4">
                        <span className="flex gap-1 flex-wrap">
                          {r.keys.map((k, j) => (
                            <span key={j} className="flex items-center">
                              {j > 0 && <span className="text-gray-400 mx-1 text-xs">+</span>}
                              <Key>{k}</Key>
                            </span>
                          ))}
                        </span>
                      </td>
                      <td className="py-2 text-gray-700">{r.desc}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          ))}
        </div>
        <div className="px-6 py-3 bg-gray-50 border-t border-gray-100 text-xs text-gray-500 rounded-b-2xl">
          Press <Key>Esc</Key> to close.
        </div>
      </div>
    </div>
  )
}
